<template>
  <div class="edit-extra-variable">
    <!-- <form  @submit.stop.prevent v-if="!loading"> -->
    <div v-if="!loading">
      <div v-if="!renaming" class="name-input">
        <custom-input
          v-if="selectedVariable.name"
          v-model="formattedName"
          :inputType="'text'"
          :name="'selectedVariableName'"
          :label="$t('extra-variables.name')"
          :placeholder="$t('extra-variables.name')"
          :isDisabled="true"
        />
        <p v-if="variableCategory" class="text-muted small">{{ $t("extra-variables.in") }} {{ variableCategory }}</p>
        <div
          v-show="!renaming"
          class="rename-var"
          @click="onRenameVariable"
          :tooltip="$t('template-syns.edit-name')"
          :tooltip-placement="'left'"
        >
          <i class="fa-light fa-pen"></i>
        </div>
      </div>
      <form v-else class="rename-form" @submit.stop.prevent="renameVariable">
        <custom-input
          ref="editName"
          v-model="newName"
          :inputType="'text'"
          :name="'selectedVariableName'"
          :label="$t('extra-variables.name')"
          :placeholder="$t('extra-variables.name')"
        />
        <button
          v-show="renaming"
          type="submit"
          class="btn checkmark"
          :disabled="newName == '' || (!nameIsSelf && invalidName) || !invalidChars"
        >
          <i class="fa-light fa-check"></i>
        </button>
        <span v-if="invalidName && !nameIsSelf" class="text-danger text-xs">
          {{ $t("template-syns.duplicate-name-err") }}
          <br />
        </span>
        <span v-if="!invalidChars" class="text-danger text-xs">
          {{ $t("template-syns.invalid-name-err") }}
          <br />
        </span>
      </form>

      <custom-input
        :inputType="'text'"
        v-model="varTypeModel"
        :name="'selectedVariableType'"
        :label="$t('extra-variables.type-label')"
        :placeholder="'Type..'"
        :isDisabled="true"
        :readonly="true"
      />
      <custom-input
        :inputType="'text'"
        v-if="selectedVariable.expression && varType !== 'Dictionary'"
        v-model="selectedVariableCopy.expression"
        :name="'selectedVariableExpression'"
        :label="'Expression'"
        :placeholder="'Expression..'"
        :optionBtn="true"
        :btnText="$t('extra-variables.add-var-btn')"
        @option-btn-clicked="$emit('get-variable-groups'), (stagedInputField = 'expression')"
      />

      <!-- in case its a dictionary type, switch the input with a button -->
      <div
        class="form-group dictionary-group"
        v-if="selectedVariable.expression && selectedVariable.mappings && varType == 'Dictionary'"
      >
        <label>{{ $t("extra-variables.variable") }}</label>
        <button
          class="btn btn-secondary"
          id="btn-selected-variable"
          @click="
            $emit('get-variable-groups', selectedVariable.customVariableType == 'ListDictionary' ? ['List'] : null),
              (stagedInputField = 'expression')
          "
          type="button"
        >
          {{
            selectedVariableCopy.expression
              ? selectedVariableCopy.expression.substring(1, selectedVariableCopy.expression.length - 1)
              : $t("extra-variables.add-var-btn")
          }}
        </button>
      </div>
      <div v-for="(ifThenInstance, index) in selectedVariableCopy.ifThenList" :key="index">
        <custom-input
          :class="stagedInputField == 'if' ? 'active-input' : ''"
          :inputType="'text'"
          v-model="selectedVariableCopy.ifThenList[index].ifCondition"
          :name="'exraVariableIfStatement' + index"
          :label="$t('extra-variables.if')"
          :placeholder="$t('extra-variables.if') + '..'"
          :optionBtn="true"
          :btnText="$t('extra-variables.add-var-btn')"
          @option-btn-clicked="
            $emit('get-variable-groups'),
              (stagedInputField = {
                name: 'ifCondition',
                index: index,
              })
          "
        />
        <custom-input
          :class="stagedInputField == 'then' ? 'active-input' : ''"
          :inputType="'text'"
          v-model="selectedVariableCopy.ifThenList[index].then"
          :name="'exraVariableThenStatement' + index"
          :label="$t('extra-variables.then')"
          :placeholder="$t('extra-variables.then') + '..'"
          :optionBtn="true"
          :btnText="$t('extra-variables.add-var-btn')"
          @option-btn-clicked="
            $emit('get-variable-groups'),
              (stagedInputField = {
                name: 'then',
                index: index,
              })
          "
        />
        <div v-if="selectedVariableCopy.ifThenList.length > 1" class="btn btn-xs" @click="removeIfInstance(index)">
          - {{ $t("remove") }}
        </div>
        <br />
        <div class="btn btn-xs" @click="newIfInstance">+ If</div>
      </div>

      <custom-input
        :class="stagedInputField == 'else' ? 'active-input' : ''"
        :inputType="'text'"
        v-if="selectedVariable.else"
        v-model="selectedVariableCopy.else"
        :name="'exraVariableElseStatement'"
        :label="$t('extra-variables.else')"
        :placeholder="$t('extra-variables.else-placeholder')"
        :optionBtn="true"
        :btnText="$t('extra-variables.add-var-btn')"
        @option-btn-clicked="$emit('get-variable-groups'), (stagedInputField = 'else')"
      />

      <div class="select-dropdown form-group" v-if="selectedVariable.type">
        <label for="formatType" :class="{ hide: !selectedVariableCopy.type }" style="margin-bottom: 0; margin-top: 10px"
          >Output type</label
        >
        <select name="formatType" class="form-control selector" v-model="selectedVariableCopy.type" required>
          <option disabled value="">Output type</option>
          <option value="Text">{{ $t("extra-variables.text") }}</option>
          <option value="Number">{{ $t("extra-variables.number") }}</option>
          <option value="List">{{ $t("extra-variables.list") }}</option>
          <option value="Bool">{{ $t("extra-variables.bool") }}</option>
          <option value="Date">{{ $t("extra-variables.date") }}</option>
          <option value="Timespan">{{ $t("extra-variables.timespan") }}</option>
        </select>
      </div>

      <dictionary-adder
        v-if="selectedVariable.mappings && varType == 'Dictionary'"
        :selectedVariable="selectedVariable"
        :mappings="mappings"
        :focusInput="true"
      />

      <div class="mappings" v-if="selectedVariable.mappings">
        <div class="mapping" v-for="(map, index) in mappings" :key="index" style="position: relative">
          <div class="row">
            <custom-input
              class="col-lg-5 arrow"
              :inputType="'text'"
              v-model="map.string"
              :name="`mapString${index}`"
              :label="$t('extra-variables.if')"
              :placeholder="$t('extra-variables.if-placeholder')"
            />
            <custom-input
              class="col-lg-6"
              :inputType="'text'"
              v-model="map.expression"
              :name="`mapExpression${index}`"
              :label="$t('extra-variables.then')"
              :placeholder="$t('extra-variables.then-placeholder')"
            />

            <button :disabled="undeleteable" type="button" class="btn col-lg-1" @click="removeMapping(map, index)">
              <img src="@/assets/svg/trash-button-no-circle.svg" />
            </button>
            <div v-if="undeleteable" class="delete-alert">
              <span class="text-danger">{{ $t("extra-variables.undeleteable-msg") }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="advanced-options" v-if="selectedVariable.mappings && varType == 'Dictionary'">
        <div class="advanced-options-header text-xs"  @click="advancedIsOpen = !advancedIsOpen">
          <span>Advanced</span>
          <div :class="{ 'flip-chevron': advancedIsOpen }">
            <i class="fa-light fa-chevron-down"></i>
          </div>
        </div>
        <div v-if="advancedIsOpen">
          <custom-input
            :inputType="'text'"
            :focusInputField="true"
            v-model="selectedVariableCopy.dictionaryInputFormat"
            :name="'dictionaryInputFormat'"
            :label="'Input format'"
            :placeholder="'Type a format for the input'"
          />
          <custom-input
            :inputType="'text'"
            v-model="selectedVariableCopy.dictionaryOutputExpression"
            :name="'dictionaryOutputExpression'"
            :label="'Output expression'"
            :placeholder="'Type an expression for the output'"
          />
        </div>
      </div>
    </div>
    <!-- </form> -->
  </div>
</template>
<script>
import VariableHelpers from "@/assets/js/variableHelpers";
import CustomInput from "@/components/CustomInput";
import DictionaryAdder from "@/components/DictionaryAdder";
import EventBus from "@/assets/js/eventBus.js";
import isEqual from "lodash/isEqual"
export default {
  name: "editExtraVariable",
  data() {
    return {
      selectedVariableCopy: {},
      loading: true,
      stagedInputField: null,
      changesDetected: false,
      mappings: [],
      watchMappings: false,
      addMappingEntry: false,
      renaming: false,
      newName: "",
      advancedIsOpen: false,
    };
  },
  props: {
    selectedVariable: Object,
    varType: String,
  },

  methods: {
    variablePattern(query) {
      return new RegExp("{" + query + "(:[^}]+)?}", "g");
    },

    renameVariable() {
      if (this.newName !== this.selectedVariable.name) {
        //Rename
        const query = this.selectedVariable.name.replaceAll(/{|}/g, "");
        const replacement = this.newName;
        const pattern = this.variablePattern(query);
        this.$store.commit("replaceTextByRegex", { query: query, replacement: replacement, pattern: pattern });
        this.$store.commit("replaceVariablesInConditions", { query: query, replacement: replacement, pattern: pattern });

        this.$emit("update-var", this.selectedVariableCopy, this.newName);
      }
      this.renaming = false;
      this.newName = null;
    },

    onRenameVariable() {
      this.newName = this.selectedVariableCopy.name.replaceAll(/{|}/g, "");
      this.renaming = true;
      this.$nextTick(() => {
        this.$refs.editName.focus();
      });
    },
    newIfInstance() {
      this.selectedVariableCopy.ifThenList.push({
        ifCondition: "",
        then: "",
      });
      this.$emit("detect-changes");
    },
    removeIfInstance(index) {
      this.selectedVariableCopy.ifThenList.splice(index, 1);
      this.$emit("detect-changes");
    },
    addToExpression(variable) {
      if (this.selectedVariable.mappings && this.stagedInputField == "expression") {
        this.selectedVariableCopy[this.stagedInputField] = variable;
      } else if (this.selectedVariableCopy.customVariableType == "If" && typeof this.stagedInputField == "object") {
        this.selectedVariableCopy.ifThenList[this.stagedInputField.index][this.stagedInputField.name] =
          this.selectedVariableCopy.ifThenList[this.stagedInputField.index][this.stagedInputField.name] + variable;
        this.stagedInputField = null;
      } else {
        this.selectedVariableCopy[this.stagedInputField] = this.selectedVariableCopy[this.stagedInputField] + variable;
        this.stagedInputField = null;
      }
    },
    onSave() {
      if (this.mappings && this.varType == "Dictionary") {
        let formattedMapping = {};
        this.mappings.forEach((mapping) => {
          formattedMapping[mapping.string] = mapping.expression;
        });
        this.selectedVariableCopy.mappings = formattedMapping;
      }

      // console.log(Object.entries(this.selectedVariableCopy))
      // console.log(Object.entries(this.selectedVariableCopy).filter((([key, value]) => key !== 'name' && key !== 'referencedVariables')))

      console.log(this.selectedVariableCopy)
      this.selectedVariableCopy.referencedVariables = [
        ...new Set(
          (
            VariableHelpers.findInText(
              Object.entries(this.selectedVariableCopy)
                .filter(([key, value]) => key !== "name" && key !== "referencedVariables")
                .join(""),
            ) || []
          ).map((v) => VariableHelpers.removeBrackets(v)),
        ),
        "format",
      ];
      if(this.selectedVariableCopy.hasOwnProperty('ifThenList')){
        let res = [];
        this.selectedVariableCopy.ifThenList.forEach(e => {
          res = res.concat(VariableHelpers.findInText(Object.entries(e).join("")))
        })  
        this.$set(
          this.selectedVariableCopy, 
          "referencedVariables",  
          this.selectedVariableCopy.referencedVariables.concat(res.map((v) => VariableHelpers.removeBrackets(v)))
        )
      }
      this.$emit("update-var", this.selectedVariableCopy);
      this.changesDetected = false;
    },
    addToMappings() {
      let mapEntry = {
        string: this.newMap.string,
        expression: this.newMap.expression,
      };
      //  this.mappings.push(mapEntry)
      this.mappings.splice(0, 0, mapEntry);
      this.newMap.string = "";
      this.newMap.expression = "";
      this.changesDetected = true;
    },
    removeMapping(mapping, index) {
      this.mappings.splice(index, 1);
      this.changesDetected = true;
    },
    formatMappings() {
      if (this.selectedVariable.mappings) {
        this.mappings = [];
        this.changesDetected = false;
        this.watchMappings = false;
        Object.entries(this.selectedVariable.mappings).forEach((item) => {
          const mappingEntry = {
            string: item[0],
            expression: item[1],
          };
          this.mappings.push(mappingEntry);
        });
        this.$nextTick(() => (this.watchMappings = true));
      }
    },
    resetVariable() {
      this.changesDetected = false;
    },
    unfocusInput() {
      this.stagedInputField = null;
    },
  },
  computed: {
    invalidName() {
      return this.$store.state.template.extraVariables.some(
        (extraVar) => extraVar.name.replaceAll(/{|}/g, "") == this.newName,
      );
    },
    nameIsSelf() {
      return this.newName == this.selectedVariableCopy.name.replaceAll(/{|}/g, "");
    },
    invalidChars() {
      return !this.newName.match(/[{|}:]/g);
    },

    formattedName() {
      // return this.selectedVariable.name.includes('{extra-variables_') ?  this.selectedVariable.name.substring(17, this.selectedVariable.name.length-1) : this.selectedVariable.name.substring(1, this.selectedVariable.name.length-1)
      return this.selectedVariable.name.includes("_")
        ? this.selectedVariable.name.substring(
            this.selectedVariable.name.lastIndexOf("_") + 1,
            this.selectedVariable.name.length - 1,
          )
        : this.selectedVariable.name.substring(1, this.selectedVariable.name.length - 1);
    },
    variableCategory() {
      return this.selectedVariable.name.includes("_")
        ? this.selectedVariable.name.substring(1, this.selectedVariable.name.lastIndexOf("_")).replaceAll("_", " → ")
        : null;
    },
    varTypeModel() {
      if (this.varType == "Dictionary") return this.$t("extra-variables.dictionary");
      if (this.varType == "If") return this.$t("extra-variables.if");
      else return this.varType;
    },
    undeleteable() {
      if (this.varType == "Dictionary" && this.mappings.length == 1) return true;
      else return false;
    },

    changes(){
      return !isEqual(this.selectedVariable, this.selectedVariableCopy)
    }
  },
  created() {
    this.formatMappings();
    this.selectedVariableCopy = JSON.parse(JSON.stringify(this.selectedVariable));
    this.loading = false;
  },
  watch: {
    selectedVariable: {
      handler: function(val, oldVal) {
        this.formatMappings();
        this.selectedVariableCopy = null;
        this.selectedVariableCopy = JSON.parse(JSON.stringify(this.selectedVariable));
        if (this.selectedVariable.customVariableType == "If" && !this.selectedVariable.ifThenList) {
          this.selectedVariableCopy = {
            name: this.selectedVariable.name,
            type: this.selectedVariable.type,
            else: this.selectedVariable.else,
            ifThenList: [
              {
                ifCondition: this.selectedVariable.if,
                then: this.selectedVariable.then,
              },
            ],
            referencedVariables: this.selectedVariable.referencedVariables,
          };
          this.$emit("detect-changes");
        }
        if (this.selectedVariable.elseIf) {
          this.selectedVariableCopy.ifThenList.push({
            ifCondition: this.selectedVariable.elseIf,
            then: this.selectedVariable.elseIfThen,
          });
        }

        this.renaming = false;
        this.newName = null;
        this.hasChanges = false;
      },
    },
    selectedVariableCopy: {
      handler: function(val, oldVal) {
        if(this.changes) this.$emit("detect-changes");
      },
      deep: true,
    },
    mappings: {
      handler: function(val, oldVal) {
        if (this.watchMappings == true) {
          (this.changesDetected = true), this.$emit("detect-changes");
        }
      },
      deep: true,
    },
    changesDetected: {
      handler: function(val, oldVal) {
        if (this.changesDetected == true) {
          this.$emit("detect-changes");
        }
      },
    },
  },
  mounted() {
    EventBus.$on("add-to-expression", this.addToExpression);
    EventBus.$on("save-extra-variable", this.onSave);
    EventBus.$on("new-selected-variable", this.resetVariable);
    EventBus.$on("vars-closed", this.unfocusInput);
  },
  destroyed() {
    EventBus.$off("vars-closed");
    EventBus.$off("new-selected-variable");
    EventBus.$off("save-extra-variable");
    EventBus.$off("add-to-expression");
  },
  components: {
    CustomInput,
    DictionaryAdder,
  },
};
</script>

<style lang="less">
.edit-extra-variable {
  background-color: #fff;
  margin: 12px;
  padding-bottom: 35px;
  .dictionary-group {
    display: flex;
    flex-direction: column;
    #btn-selected-variable {
      // height: 36px;
      width: max-content;
      // font-family: "Roboto", sans-serif;
      &:hover {
        // box-shadow: 5px 4px 4px 2px rgba(0, 0, 0, 0.25);
      }
    }
  }
  .rename-form,
  .name-input {
    position: relative;
    .rename-var,
    .checkmark {
      cursor: pointer;
      position: absolute;
      right: 12px;
      top: 38px;
      padding: 0;
    }
    span {
      position: absolute;
      bottom: -14px;
    }
  }

  .delete-alert {
    display: none;

    span {
      visibility: hidden;
      opacity: 0;
      transition: 2s;
    }
  }

  .mappings {
    .mapping {
      position: relative;
      padding: 0 12px 12px 12px;
      button {
        z-index: 1;
        padding: 0;
        margin-top: 30px;
        padding-right: 10px;

        &:hover + .delete-alert {
          display: block;

          span {
            visibility: visible;
            box-shadow: 5px 4px 4px 2px rgba(0, 0, 0, 0.25);
            opacity: 1;
            background-color: #fafafa;
            padding: 12px;
            transition: 2s;
            position: absolute;
            top: 10px;
            right: 30px;
            z-index: 2;
          }
        }
      }
    }
  }
  .arrow::after {
    content: "→";
    position: absolute;
    right: -8px;
    top: 40px;
  }
  .actions {
    float: right;
    button {
      margin: 10px 0px 10px 5px;
    }
    .btn-secondary {
      padding: 2px 12px;
    }
  }
}
</style>
